import styled from 'styled-components';

export const Select = styled.select`
  background: transparent;
  border: none;
  width: 16rem;
  text-transform: uppercase;
  font-size: 1.6rem;
`;
